import React from "react";
import { QueryEditorProps } from "../../../Interfaces/PromptPlayground.interfaces";
import { playgroundClassNames as classNames, playgroundStyles as styles } from "../../../Styles";
import { KustoExplorerDialog } from "../../Dialogs/KustoExplorerDialog";
import { TextFieldWithActions } from "../TextFieldWithActions";
import { logEvent } from "../../../../../helper/AppInsightsHelper";

export const QueryEditor: React.FC<QueryEditorProps> = ({ query, onChange, onCopy, onOpenInADX }) => {
  const [showKustoDialog, setShowKustoDialog] = React.useState(false);

  const handleOpenInADX = (queryText: string) => {
    if (queryText.trim()) {
      setShowKustoDialog(true);
    }
    logEvent("Open in ADX link clicked", "AI Hub - KQL Mode", "QueryEditor", { query: queryText });
  };

  const handleKustoDialogClose = () => {
    setShowKustoDialog(false);
  };

  const handleRedirectComplete = () => {
    // Call the original onOpenInADX function after dialog completes
    onOpenInADX(query);
  };

  return (
    <>
      <TextFieldWithActions
        actionButtons={[
          {
            disabled: !query.trim(),
            iconName: "OpenInNewWindow",
            onClick: () => handleOpenInADX(query),
            style: { position: "relative" },
            title: "Open in Azure Data Explorer (ADX)"
          },
          {
            disabled: !query.trim(),
            iconName: "Copy",
            onClick: () => onCopy(query),
            style: { position: "relative" },
            title: "Copy query to clipboard"
          }
        ]}
        actionButtonClassName={classNames.copyIconStyle}
        containerClassName={classNames.textFieldContainerStyle}
        helpLinkText="Open in Azure Data Explorer to explore schema and add more columns"
        label="Kusto Query"
        onChange={onChange}
        onHelpLinkClick={() => handleOpenInADX(query)}
        rows={15}
        showHelpLink={true}
        textFieldStyles={styles.textFieldStyles}
        value={query}
      />
      <KustoExplorerDialog
        open={showKustoDialog}
        onClose={handleKustoDialogClose}
        query={query}
        onRedirectComplete={handleRedirectComplete}
      />
    </>
  );
};
